<div *ngIf="message">
  <ami-dialog-message [setting]="message"></ami-dialog-message>
</div>

<div class="card">
  <div class="flex justify-content-center">
    <div class="flex align-items-center justify-content-center">
      <div class="grid">
        <form [formGroup]="fg">
          <div class="col-12 md:col-11 grid">
            <div class="col-12 md:col-11">
              <span class="block text-3xl font-medium text-900 mt-2"
                >Traslado
              </span>
            </div>
            <div class="col-12 md:col-1 mt-2">
              <pg-cart-sale></pg-cart-sale>
            </div>
            <div class="col-12">
              <p-message
                severity="info"
                text="Registre los productos en su stock-sucursal desde su stock inicial, Asegurese de ingresar los datos correctamente."
                styleClass="p-mr-2"
              ></p-message>
            </div>
          </div>
          <div class="field col-12 md:col-12 mb-4">
            <pg-branch-store-details
              (onSelect)="branchStoreOriginSelected.onSelect($event)"
              [legend]="branchStoreOriginSelected.legend"
            ></pg-branch-store-details>
          </div>
          <div class="field col-12 md:col-12 mb-4">
            <pg-branch-store-details
              (onSelect)="branchStoreDestineSelected.onSelect($event)"
              [legend]="branchStoreDestineSelected.legend"
            ></pg-branch-store-details>
          </div>
          <pg-products-sale
            [branchStoreId]="branchStoreOriginSelected.getId()"
          ></pg-products-sale>
          <div class="flex justify-content-center card-container mt-3">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              [disabled]="fg.invalid || isCartEmpty() || !areBranchStoresSelected() || !areBranchStoresDiferent()"
              class="p-button-sg p-button-success"
              pTooltip="Agregar Stock"
              tooltipPosition="bottom"
            >
              CONFIRMAR OPERACIÓN
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
